import { SupermarketBrand } from "../data/supermarkets";

export interface SupermarketPoi {
  brandId: string;
  brandName: string;
  name: string;
  address?: string;
  longitude: number;
  latitude: number;
  distanceMeters?: number;
}

const SEARCH_BOX_BASE = "https://api.mapbox.com/search/searchbox/v1";

async function searchBrandNear(
  lat: number,
  lon: number,
  brand: SupermarketBrand,
  token: string
): Promise<SupermarketPoi | null> {
  for (const term of brand.searchTerms) {
    const params = new URLSearchParams({
      q: term,
      proximity: `${lon},${lat}`,
      limit: "3",
      access_token: token,
      language: "en",
      country: "GB",
    });

    const res = await fetch(`${SEARCH_BOX_BASE}/forward?${params}`);
    if (!res.ok) continue;
    const data = await res.json();
    const features = Array.isArray(data.features) ? data.features : [];
    const feature = features[0];
    if (!feature?.geometry?.coordinates) continue;

    const [longitude, latitude] = feature.geometry.coordinates as [
      number,
      number,
    ];
    const props = feature.properties ?? {};

    return {
      brandId: brand.id,
      brandName: brand.name,
      name: String(props.name ?? props.name_preferred ?? brand.name),
      address: String(
        props.full_address ??
          props.place_formatted ??
          feature.place_name ??
          ""
      ),
      longitude,
      latitude,
      distanceMeters:
        typeof props.distance === "number" ? props.distance : undefined,
    };
  }
  return null;
}

export async function findSupermarketsNear(
  lat: number,
  lon: number,
  brands: SupermarketBrand[],
  token: string
): Promise<SupermarketPoi[]> {
  const results = await Promise.all(
    brands.map((brand) => searchBrandNear(lat, lon, brand, token))
  );
  return results
    .filter((r): r is SupermarketPoi => r != null)
    .sort(
      (a, b) =>
        (a.distanceMeters ?? Number.MAX_SAFE_INTEGER) -
        (b.distanceMeters ?? Number.MAX_SAFE_INTEGER)
    );
}
